<div *ngIf="selectedReferral != null">
    <p-panel>
        <ng-template pTemplate="header">
            <div class="flex flex-row-reverse w-full">
                <div class="flex gap-2 align-items-center m-2">
                    <p-button icon="pi pi-file"  label="View Submission" [raised]="true" (onClick)="submissionVisible = true"></p-button>
                    <p-dialog appendTo="body" [(visible)]="submissionVisible" [style]="{width: '45vw', height:'100vh',position:'absolute',left:'2vw'}" styleClass="flex overflow-auto">
                        <app-submission-viewer *ngIf="selectedReferral" [submission]="selectedReferral.submission"></app-submission-viewer>
                    </p-dialog>
                </div>
                <div *ngIf="encounter" class="flex align-items-center justify-content-center m-2">
                    <p-buttonGroup>
                        <p-button label="Diaries" icon="pi pi-book" (click)="diaryOp.toggle($event)"/>
                        <p-button label="Notes" icon="pi pi-pencil" (click)="noteOp.toggle($event)"/>
                        <p-button label="Email" icon="pi pi-send" (click)="emailDialogVisible = true"/>
                        <p-button label="Attachments" icon="pi pi-file" (click)="attachmentOp.toggle($event)"/>
                    </p-buttonGroup>
                    <p-overlayPanel #diaryOp [style]="{width: '50vw', height:'40vh'}" styleClass="overflow-y-scroll">
                        <app-diary-list [handler]="encounterDiaryHandler" [diaries]="encounter.diaries"></app-diary-list>
                    </p-overlayPanel>
                    <p-overlayPanel #noteOp [style]="{width: '50vw', height:'40vh'}" styleClass="overflow-y-scroll">
                        <app-encounter-notes-list [handler]="encounterNoteHandler" [encounter]="encounter" [notes]="encounter.notes"></app-encounter-notes-list>
                    </p-overlayPanel>
                    <p-dialog #emailOp [visible]="emailDialogVisible" [style]="{width: '50vw', height:'40vh'}" styleClass="overflow-y-scroll">
                        <div class="flex flex-column gap-2">
                            <p-tabView>
                                <p-tabPanel header="Sent">
                                    <app-sent-email-list [emailHandler]="encounterEmailHandler" [emails]="encounter.sentEmails"></app-sent-email-list>
                                </p-tabPanel>
                                <p-tabPanel header="Received">
                                    <app-received-email-list [emails]="encounter.receivedEmails"></app-received-email-list>
                                </p-tabPanel>
                            </p-tabView>
                        </div>
                    </p-dialog>
                    <p-overlayPanel #attachmentOp [style]="{width: '50vw', height:'40vh'}" styleClass="overflow-y-scroll">
                        <app-file-list [files]="selectedReferral.attachments" [uploader]="uploader" (modified)="attachmentsChanged($event)"></app-file-list>
                    </p-overlayPanel>
                </div>
            </div>
        </ng-template>
        <p-accordion [activeIndex]="0">
            <p-accordionTab>
                <ng-template pTemplate="header">
                    <span class="mr-4">Injured Worker Info</span>
                    <span class="ml-4"><ng-icon *ngIf="selectedParty" name="bootstrapCheckCircleFill" color="green" size="2em"></ng-icon></span>
                </ng-template>
                <div *ngIf="!selectedParty" class="grid formgrid p-fluid align-items-center">
                    <div class="field mb-4 col-2">
                        <div>
                            <p-button icon="pi pi-file-import" [raised]="true" [rounded]="true" [text]="true" (onClick)="partySearch.searchFor(selectedReferral.submission.patientFirstName + ' ' + selectedReferral.submission.patientLastName) " ></p-button>
                        </div>
                    </div>
                    <div class="field mb-4 col-8">
                        <div>
                            <app-party-search #partySearch (partySelected)="partySelected($event)" placeholder="Search Existing"></app-party-search>
                        </div>
                    </div>
                    <div class="field mb-4 col-2">
                        <div>
                            <p-button icon="pi pi-plus" [rounded]="true" [text]="true" [raised]="true" (onClick)="newPartyOp.toggle($event)"></p-button>

                            <p-overlayPanel #newPartyOp [style]="{height:'480px', overflow:'scroll'}">
                                <app-party-editor  (saved)="newPartyOp.hide(); partyCreated($event)" (cancelled)="newPartyOp.hide()"  ></app-party-editor>
                            </p-overlayPanel>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedParty" class="card">
                    <p-card header="Injured Worker">
                        <div class="flex flex-auto">
                            <div class="flex flex-auto justify-content-start align-items-center">{{selectedParty.firstName}} {{selectedParty.lastName}}</div>
                            <div class="flex justify-content-end align-items-end">
                                <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [text]="true" [raised]="true" (onClick)="editPartyOp.toggle($event)"></p-button>
                                <p-overlayPanel #editPartyOp [style]="{height:'480px', overflow:'scroll'}">
                                    <app-party-editor [party]="selectedParty" (saved)="editPartyOp.hide(); partyEdited(selectedParty.id,$event)" (cancelled)="editPartyOp.hide()"  ></app-party-editor>
                                </p-overlayPanel>
                            </div>
                            <div class="flex justify-content-end align-items-end">
                                <p-button icon="pi pi-trash" [rounded]="true" [text]="true" [raised]="true" (onClick)="selectedParty = undefined"></p-button>
                            </div>
                        </div>
                    </p-card>
                </div>
            </p-accordionTab>
            <p-accordionTab [disabled]="!selectedParty">
                <ng-template pTemplate="header">
                    <span class="mr-4">Claim Info</span>
                    <span class="ml-4"><ng-icon *ngIf="selectedReferral.claim" name="bootstrapCheckCircleFill" color="green" size="2em"></ng-icon></span>
                </ng-template>
                <div *ngIf="!selectedReferral.claim" class="grid formgrid p-fluid align-items-center">
                    <div class="field mb-4 col-10">
                        <div>
                            <p-dropdown [options]="existingClaims" [(ngModel)]="selectedReferral.claim" optionLabel="displayName" placeholder="Select Existing Claim"></p-dropdown>
                        </div>
                    </div>
                    <div class="field mb-4 col-2">
                        <div>
                            <p-button icon="pi pi-plus" [rounded]="true" [text]="true" [raised]="true" (onClick)="newClaimOp.toggle($event)"></p-button>
                            <p-overlayPanel #newClaimOp [dismissable]="false"  [style]="{width: '50vw', height:'50vh'}" styleClass="flex overflow-auto">
                                <app-claim-editor (saved)="newClaimOp.hide(); claimCreated($event)" (cancelled)="newClaimOp.hide()"></app-claim-editor>
                            </p-overlayPanel>
                        </div>
                    </div>
                </div>
                <div *ngIf="selectedReferral.claim" class="card">
                    <p-card header="Claim">
                        <div class="flex flex-auto">
                            <div class="flex flex-auto justify-content-start align-items-center">{{selectedReferral.claim.claimNumber}} {{selectedReferral.claim.claimDate | date: 'shortDate'}}</div>
                            <div class="flex justify-content-end align-items-end">
                                <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [text]="true" [raised]="true" (onClick)="editClaimOp.toggle($event)"></p-button>
                                <p-overlayPanel #editClaimOp [dismissable]="false"  [style]="{width: '50vw', height:'50vh'}" styleClass="flex overflow-auto">
                                    <app-claim-editor [claim] ="selectedReferral.claim" (saved)="editClaimOp.hide(); claimEdited(selectedReferral.claim.id,$event)" (cancelled)="editClaimOp.hide()"  ></app-claim-editor>
                                </p-overlayPanel>
                            </div>
                            <div class="flex justify-content-end align-items-center">
                                <p-button icon="pi pi-trash" [rounded]="true" [text]="true" [raised]="true" (onClick)="selectedReferral.claim = undefined"></p-button>
                            </div>
                        </div>
                    </p-card>
                </div>
            </p-accordionTab>
            <p-accordionTab>
                <ng-template pTemplate="header">
                    <span class="mr-4">Procedure Info</span>
                    <span class="ml-4"><ng-icon *ngIf="selectedReferral && selectedReferral.procedures.length > 0 && selectedReferral.referringProvider != null && selectedReferral.servicingProvider != null" name="bootstrapCheckCircleFill" color="green" size="2em"></ng-icon></span>
                </ng-template>
                <div class="grid formgrid p-fluid align-items-center">
                    <div class="field mb-4 col-10">
                        <div>
                            <app-procedure-selector #ps (procedureSelected)="procedureSelected($event)"></app-procedure-selector>
                        </div>
                    </div>
                    <div class="field mb-4 col-2">
                        <div>
                            <p-button icon="pi pi-plus" [rounded]="true" [text]="true" [raised]="true" label="Add" (onClick)="addSelectedProcedure($event); ps.resetSelection()"></p-button>
                        </div>
                    </div>
                    <div *ngIf="selectedReferral.procedures" class="field mb-4 col-12 grid flex flex-column">
                        <div *ngFor="let procedure of selectedReferral.procedures" class="flex flex-row">
                            <p-chip  [label]="procedure.displayName" class="mt-2 mb-2 flex-auto"></p-chip>
                            <p-button icon="pi pi-trash" [raised]="true" [rounded]="true" [text]="true" (onClick)="removeProcedure(procedure)"></p-button>
                        </div>
                    </div>
                    <div class="field mb-4 col-2">
                        <div>
                            <p-button icon="pi pi-file-import" [raised]="true" [rounded]="true" [text]="true" (onClick)="referringFacilitySearch.searchFor(selectedReferral.submission.referringProvider) " ></p-button>
                        </div>
                    </div>
                    <div class="field mb-4 col-10">
                        <app-facility-location-search #referringFacilitySearch [(facility)]="selectedReferral.referringProvider" placeholder="Ordering Provider" ></app-facility-location-search>
                    </div>

                    <div class="field mb-4 col-2">
                        <div>
                            <p-button icon="pi pi-file-import" [raised]="true" [rounded]="true" [text]="true" (onClick)="servicingFacilitySearch.searchFor(selectedReferral.submission.servicingProvider) " ></p-button>
                        </div>
                    </div>
                    <div class="field mb-4 col-10">
                        <app-facility-location-search #servicingFacilitySearch [(facility)]="selectedReferral.servicingProvider" placeholder="Servicing Provider" ></app-facility-location-search>
                    </div>
                </div>
            </p-accordionTab>
            <p-accordionTab>
                <ng-template pTemplate="header">
                    <span class="mr-4">Submission Info</span>
                    <span class="ml-4"><ng-icon *ngIf="submitterInfoComplete()" name="bootstrapCheckCircleFill" color="green" size="2em"></ng-icon></span>
                </ng-template>
                <div class="flex flex-row flex-row-reverse p-1 pr-6">
                    <p-button *ngIf="selectedReferral" icon="pi pi-file-import" [rounded]="true" [text]="true" [raised]="true" (onClick)="fillFromSubmission()"></p-button>
                    <p-button icon="pi pi-eraser" [rounded]="true" [text]="true" [raised]="true" (onClick)="clearForm()" class="mr-2 ml-2"></p-button>
                </div>
                <div *ngIf="selectedReferral" class="grid formgrid p-fluid align-items-center">
                    <div class="field mb-4 col-6">
                        <p-floatLabel>
                            <input id="submitterName" pInputText [(ngModel)]="selectedReferral.submitterName" />
                            <label for="submitterName">Submitter Name</label>
                        </p-floatLabel>
                    </div>
                    <div class="field mb-4 col-6">

                        <p-floatLabel>
                            <p-dropdown id="jobFunction" [options]="submitterTypes" [(ngModel)]="selectedReferral.submitterJobFunction" showClear></p-dropdown>
                            <label for="jobFunction">Job Function</label>
                        </p-floatLabel>
                    </div>
                    <div class="field mb-4 col-6">
                        <p-floatLabel>
                            <input id="submitterEmail" pInputText [(ngModel)]="selectedReferral.submitterEmail" />
                            <label for="submitterEmail">Submitter Email</label>
                        </p-floatLabel>
                    </div>
                    <div class="field mb-4 col-6">
                        <p-floatLabel>
                            <input id="submitterPhone" pInputText [(ngModel)]="selectedReferral.submitterPhone" />
                            <label for="submitterPhone">Submitter Phone</label>
                        </p-floatLabel>
                    </div>
                    <div class="field mb-4 col-12">
                        <p-floatLabel>
                            <textarea id="specialInstructions"  rows="5" cols="45" pInputTextarea [(ngModel)]="selectedReferral.specialInstructions"></textarea>
                            <label for="specialInstructions">Special Instructions</label>
                        </p-floatLabel>
                    </div>
                </div>
            </p-accordionTab>
        </p-accordion>
    </p-panel>
    <div class="flex mt-2 col-12 justify-content-center ">
        <p-buttonGroup>
            <p-button label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
            <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
        </p-buttonGroup>
    </div>
</div>